import React from 'react'
import Title from '../layouts/Title'

const About1 = () => {
  return (
    <section
      id="about"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="Section" des="About me" />
      </div>
      <div className="max-w-6xl mx-auto">
        <p className="text-xl font-bodyFont leading-6 tracking-wide">
          In my downtime, I'm immersed in the world of games, sharing my adventures on twitch and try to have a vibrant community. As a tech-nerd, I thrive on staying updated with the latest tech and hardware. If there's any time left after this, I love to captivate myself into reading and learning about the cosmos.</p><br></br>

        <p className="text-xl font-bodyFont leading-6 tracking-wide text-aniColor">
          As for my job, I am committed to the grind and continuously pushing the boundaries of learning and expanding my portfolio. This site servers as a gateway to explore my passions and projects, and for you to learn more about me!
        </p><br></br>
        <p className="text-xl font-bodyFont leading-6 tracking-wide">
        Wish me luck!</p>
      </div>
    </section>
  )
}

export default About1